import Endpoints from "../Constants/Endpoints";
import {retrieveItem, storeItem} from "./Storage";

export const handleUserAccess = (res, globalActions, redToAccount) => {
    let user = res.data.admin;
    let token = res.data.token;

    // Merge new RBAC fields (role, permissions, sessionId) into the stored user
    // blob so that hasPermission(user, perm) works after re-hydration on boot.
    const enrichedUser = {
        ...user,
        role: res.data.role || user.role || '',
        permissions: Array.isArray(res.data.permissions) ? res.data.permissions : (user.permissions || []),
        sessionId: res.data.sessionId || res.data.session_id || '',
    };

    storeItem('user', JSON.stringify(enrichedUser));
    storeItem('token', token);
    globalActions.setCurrentUser({});
    globalActions.setCurrentUser(enrichedUser);
    globalActions.setUserLoggedIn(true);

    if (redToAccount) {
        window.location.assign(process.env.PUBLIC_URL + "/dashboard")
    }
};

/**
 * Read the persisted user from localStorage. Returns null when not logged in.
 * The returned object always has a `permissions: string[]` field so that
 * hasPermission(currentUser(), perm) works without extra null-checks.
 */
export const currentUser = () => {
    const raw = retrieveItem('user');
    if (!raw) return null;
    try {
        const user = JSON.parse(raw);
        if (!Array.isArray(user.permissions)) {
            user.permissions = [];
        }
        return user;
    } catch (_) {
        return null;
    }
};
